import { render, staticRenderFns } from "./WorkerPage.vue?vue&type=template&id=7ae54fd6&scoped=true"
import script from "./WorkerPage.vue?vue&type=script&lang=js"
export * from "./WorkerPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae54fd6",
  null
  
)

export default component.exports